export default __webpack_public_path__ + "static/media/315757517_bb90cd58cd_b.6784e435.jpg";